import { ActionReducerMapBuilder } from "@reduxjs/toolkit";
import { LocationState } from "@/redux/slice/location/types/LocationState";
import fetchPatientAddressList from "@/redux/slice/location/builders/fetchPatientAddressList";

const asyncLocationReducers = (builder: ActionReducerMapBuilder<LocationState>) => {
  fetchPatientAddressList(builder);
};

export default asyncLocationReducers;
